// extracted by mini-css-extract-plugin
module.exports = {"invalid":"Invalid_invalid__X6HWf","content":"Invalid_content__F8GcY","avatar":"Invalid_avatar__15n8i"};